import { render, staticRenderFns } from "./farmer.vue?vue&type=template&id=041b92f3&scoped=true"
import script from "./farmer.vue?vue&type=script&lang=js"
export * from "./farmer.vue?vue&type=script&lang=js"
import style0 from "./farmer.vue?vue&type=style&index=0&id=041b92f3&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041b92f3",
  null
  
)

export default component.exports